import axios from 'axios';

export const createCart = (params = {}) => axios.post('/carts', { params });
export const getCart = id => axios.get(`/carts/${id}`);
export const refreshVolumeDiscount = id => axios.post(`/carts/${id}/refresh_volume_discount`);
